import styles from "./SignUp.module.css";
import logoImage from "../Assests/Images/logo.png";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { MdOutlineMailOutline } from "react-icons/md";
import { MdLockOutline } from "react-icons/md";
import { useEffect, useState } from "react";
import { IoPersonOutline } from "react-icons/io5";
import GoogleLogo from "../Assests/Images/GoogleLogo.svg";
import Shape from "../Assests/Images/Shape.svg";
import { useNavigate } from "react-router-dom";
import { FaFacebookF } from "react-icons/fa";
import { RiArrowDropDownLine } from "react-icons/ri";
import { useDispatch } from "react-redux";
import { userSignUp } from "../redux/slices/userSlice";
import { STATUS_CODE } from "../Utils/StatusCode";
import { STATUS_MSG } from "../Utils/StatusMsg";
import Toster from "../Common/Toster/Toster";
import Loader from "../Common/Loader/Loader";
import { cleanData } from "../Utils/CommonFunction";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import {
  CustomInputField,
  CustomPasswordInputFieldForSignUp,
} from "../ReactBootstrap/CustomInputField/CustomInputField";
import GoogleLogin from "./SocialLogin/GoogleLogin";
import TwitterLogin from "./SocialLogin/TwitterLogin";
import { MASKING } from "../Utils/PhoneMasking";
import TermsAndCondition from "./TermsAndCondition/TermsAndCondition";

function SignUp() {
  const { register, handleSubmit, reset, formState, setValue } = useForm({
    mode: "onChange",
  });
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [shown, setShown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [shownConfirn, setShownConfirn] = useState(false);
  const [phone, setPhone] = useState();
  const [dialCode, setDialCode] = useState(27);
  const [countryCode, setCountryCode] = useState("za");
  const [password, setPassword] = useState("");
  const [conPassword, setConPassword] = useState("");
  const [accept, setAccept] = useState(true);
  const [passwordError, setPasswordError] = useState("");

  const [showTerm, setShowTerm] = useState(false);

  const handlOpenTerms = () => {
    setShowTerm(!showTerm);
  };

  // useEffect(() => {
  //   setAccept(true);
  // }, [showTerm]);

  const handleKeyPress = (e, t) => {
    if (e.target.value == " ") setValue(e.target.name, e.target.value.trim());
  };

  const onSubmit = (data) => {
    if (password !== conPassword) {
      setPasswordError(t("PASSWORDS_DO_NOT_MATCH"));
      return;
    } else {
      setPasswordError("");
    }
    const signUpData = {
      brandName: data.NAME,
      email: data.EMAIL,
      dialcode: dialCode,
      phone: cleanData(phone),
      countryCode: countryCode ? countryCode : "",
      password: data.PASSWORD,
    };
    const PostData = new FormData();
    PostData.append("brandName", data.NAME);
    PostData.append("email", data.EMAIL);
    if (phone?.length > 5) {
      PostData.append("dialCd", dialCode);
      PostData.append("phn", cleanData(phone.replace(/-/g, " ")));
      PostData.append("countryCd", countryCode);
    } else {
      PostData.append("dialCd", "");
      PostData.append("phn", "");
      PostData.append("countryCd", "");
    }

    PostData.append("password", data.PASSWORD);
    PostData.append("cnfPassword", data.CON_PASSWORD);

    if (
      password == conPassword &&
      (!phone || phone?.length > 4 || phone?.length == 0)
    ) {
      setIsLoading(true);
      dispatch(userSignUp(PostData)).then((res) => {
        setIsLoading(false);
        var response = res.payload;

        const ResponseCode = STATUS_MSG[response?.data.code];

        if (response?.code === STATUS_CODE.SUCCESS) {
          navigate("/verification", {
            state: { token: response?.data?.token, signUpData: signUpData },
          });

          reset();
        } else if (response?.data?.code == STATUS_CODE.VALIDATION_ERROR) {
          Toster(response?.data?.message, "error");
        } else {
          Toster(t(ResponseCode), "error");
        }
      });
    }
  };

  const handelNumberChange = (value, country) => {
    setDialCode(country?.country?.dialCode);

    setCountryCode(country?.country?.iso2);

    let phoneNumber = country?.inputValue?.slice(
      country.country.dialCode.length + 1,
      country.inputValue.length
    );
    setPhone(country?.inputValue);
    setValue("PHONE_INPUT", phoneNumber, {
      shouldValidate: true,
    });
  };

  useEffect(() => {
    setPhone(phone?.replace(/-/g, ""));
  }, [phone]);

  return (
    <div className={styles.bgSection}>
      {isLoading && <Loader />}
      <div className={styles.formSection}>
        <div className={styles.logoImg}>
          <img src={logoImage}></img>
        </div>

        <div className={styles.loginForm}>
          <div className={styles.heading}>
            <p>
              {t("BRAND_CLUB_SIGN")} <span>{t("UP")}</span>{" "}
            </p>
          </div>

          <Form onSubmit={handleSubmit(onSubmit)}>
            <CustomInputField
              styleName="signUpTabInput"
              type="type"
              PlaceHolder={t("BRAND_NAME_")}
              RegisterName="NAME"
              register={register}
              formState={formState}
              onChange={(e) => {
                handleKeyPress(e);
              }}
              icon={<IoPersonOutline />}
            >
              <p>
                {t("BRAND_NAME")} <span>({t("REQUIRED")})</span>
              </p>
            </CustomInputField>

            <CustomInputField
              styleName="signUpTabInput"
              type="type"
              PlaceHolder={t("EMAIL")}
              RegisterName="EMAIL"
              register={register}
              formState={formState}
              icon={<MdOutlineMailOutline />}
              onChange={(e) => {
                setValue("EMAIL", e.target.value.replace(/\s/g, ""), {
                  shouldValidate: true,
                });
              }}
            >
              <p>
                {t("EMAIL_ADDRESS_")} <span>({t("REQUIRED")})</span>
              </p>
            </CustomInputField>

            <Form.Group className={styles.loginInput}>
              <Form.Label>
                <p>
                  {t("MOBILE_NUMBER_")} <span>({t("OPTIONAL")})</span>
                </p>
              </Form.Label>

              <PhoneInput
                defaultCountry="za"
                countryCodeEditable={false}
                disableDialCodeAndPrefix={true}
                defaultMask={MASKING[dialCode]}
                onChange={(value, country) =>
                  handelNumberChange(value, country)
                }
                countrySelectProps={{
                  disabled: true,
                }}
              />
              <div className={styles.dialcodeShow}>
                <p>+ {dialCode}</p>
              </div>
              <div className="validateError">
                {phone?.length > 0 && phone?.length < 5
                  ? t("MOBILE_NO_MUST_BE_ATLEAST_5_DIGIT")
                  : ""}
              </div>

              <div className={styles.selectCountry}>
                <RiArrowDropDownLine color="#8B8A8A" size="30" />
              </div>
            </Form.Group>

            <CustomPasswordInputFieldForSignUp
              styleName="signUpTabInput"
              Label={
                <p>
                  {t("PASSWORD_")} <span>({t("REQUIRED")})</span>
                </p>
              }
              PlaceHolder={t("YOUR_PASSWORD")}
              RegisterName="PASSWORD"
              register={register}
              icon={<MdLockOutline />}
              formState={formState}
              onChange={(e) => {
                setPassword(e.target.value.replace(/\s/g, ""));
                setValue("PASSWORD", e.target.value.replace(/\s/g, ""), {
                  shouldValidate: true,
                });
              }}
              isVisible={shown}
              setIsVisible={setShown}
              lockIconStyle="lockIcon"
            ></CustomPasswordInputFieldForSignUp>

            <CustomPasswordInputFieldForSignUp
              styleName="signUpTabInput2"
              PlaceHolder={t("REPEAT_PASSWORD")}
              RegisterName="CON_PASSWORD"
              register={register}
              icon={<MdLockOutline />}
              formState={formState}
              onChange={(e) => {
                setConPassword(e.target.value.replace(/\s/g, ""));
                setValue("CON_PASSWORD", e.target.value.replace(/\s/g, ""), {
                  shouldValidate: true,
                });
              }}
              isVisible={shownConfirn}
              setIsVisible={setShownConfirn}
              lockIconStyle="lockIcon"
            ></CustomPasswordInputFieldForSignUp>
            {passwordError && (
              <div className={styles.errorMessage}>{passwordError}</div>
            )}

            {/* <div className="remeberChek">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  onChange={() => {
                    setAccept(!accept);
                    // if (accept) {
                    //   handlOpenTerms();
                    // }
                  }}
                  id="flexCheckDefault"
                />
                <label
                  style={{ cursor: "pointer" }}
                  className="form-check-label"
                  htmlFor="flexCheckDefault"
                  onClick={() => {
                    handlOpenTerms();
                  }}
                >
                  Accept <b>terms and conditions</b> of use
                </label>
              </div>
            </div> */}

            <div className="remeberChek">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  onChange={() => {
                    setAccept(!accept);
                  }}
                  id="flexCheckDefault"
                />
                <label className="form-check-label">
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      handlOpenTerms();
                    }}
                  >
                    Accept <b>terms and conditions</b> of use
                  </span>
                </label>
              </div>
            </div>

            <div className={styles.loginBtn}>
              <button disabled={accept}>
                <p>
                  {t("REGISTER")} <span>{t("NOW")}</span>
                </p>
              </button>
            </div>
          </Form>
          <div className={styles.signUpWith}>
            <p>{t("OR_SIGN_UP")}</p>
          </div>
          <div className={styles.signInOption}>
            <div className={styles.option}>
              {/* <img
                src={GoogleLogo}
                alt="GoogleLogo"
                width="22px"
                height="22px"
              ></img> */}

              <GoogleLogin />
            </div>
            {/* <div className={styles.option}>
              <FaFacebookF size="20" />
            </div> */}
            <div className={styles.option}>
              <TwitterLogin twitterLoginFrom={"sign-up"} />
              {/* <img src={Shape} alt="Shape" width="22px" height="22px"></img> */}
            </div>
          </div>
          <div className={styles.alreadySignin}>
            <p>
              {t("ALREADY_REGISTERED?")}{" "}
              <span
                onClick={() => {
                  navigate("/login");
                }}
              >
                {t("SIGN_IN")}
              </span>
            </p>
          </div>
        </div>
      </div>
      <TermsAndCondition show={showTerm} handleClose={handlOpenTerms} />
    </div>
  );
}

export default SignUp;
